import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // These are inlined at build time, so an empty value here means the deploy
  // set them as runtime variables instead of build variables — a mistake that
  // otherwise shows up as a blank screen and a 401 with no explanation.
  throw new Error(
    'VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set as *build* variables.',
  );
}

export const supabase = createClient(url, anonKey);
